import { reorderThresholdFromMetadata } from "./reorderThreshold";

export type InventoryPoNeed = {
  material_id: string;
  material_name: string;
  quantity: number;
  rate: number | null;
};

/** Qty to buy so on-hand reaches the material's reorder threshold (metadata). */
export function inventoryPoNeedsBelowReorder(
  materials: readonly {
    id: string;
    name: string;
    plant_id: string | null;
    on_hand_qty: number;
    unit_cost: number;
    metadata: Record<string, unknown> | null;
  }[],
  plantId: string
): InventoryPoNeed[] {
  if (!plantId) return [];
  const out: InventoryPoNeed[] = [];
  for (const mat of materials) {
    if (mat.plant_id && mat.plant_id !== plantId) continue;
    const reorder = reorderThresholdFromMetadata(mat.metadata);
    if (reorder == null) continue;
    const onHand = Number(mat.on_hand_qty);
    if (!Number.isFinite(onHand)) continue;
    const raw = reorder - onHand;
    if (raw <= 0) continue;
    const quantity = Math.round(raw * 1000) / 1000;
    const cost = Number(mat.unit_cost);
    out.push({
      material_id: mat.id,
      material_name: mat.name,
      quantity,
      rate: Number.isFinite(cost) && cost > 0 ? Math.round(cost * 100) / 100 : null,
    });
  }
  return out;
}
